import React from "react";
import { useParams } from "react-router-dom";
import ProductGrid from "./home/ProductGrid";
import SEO from "./SEO";

const ShopAll = () => {
  const { categoryId, categoryName } = useParams(); // 👈 Get category name + id

  return (
    <div>
            <SEO
                    title='Blank Beanies shop All Product'
                    description='Blank Beanies'
                    keywords='Blank Beanies'
                  />
<ProductGrid categoryId="allproducts" categoryName="All Products" />      
    </div>
  );
};

export default ShopAll;
